import React, { useState, useEffect } from "react";

import useContract from "../hooks/useContract"; // Import your custom hook
import { toast } from "react-toastify"; // For notifications

import { useWeb3ModalAccount, useWeb3Modal } from "@web3modal/ethers/react";
import { useNavigate } from "react-router-dom"; // Use useNavigate for React Router v6


import { FaMoneyBill, FaShoppingCart, FaChartLine, FaExchangeAlt } from "react-icons/fa"; // Import icons



const menuItems = [
  { name: "earning", icon: "home.webp" }, // Path to the icon image
  { name: "Purchase", icon: "purchase.webp" },
  { name: "Stake", icon: "stake.webp" },
  { name: "transactions", icon: "tx.webp" },
];

const icons = {
  holdings: 'global.png',
  rewards: 't-rewards-paid.png',
  payoutTime: 'last-payout-time.png',
  nextPayout: 'total-referred.png',
  referralEarnings: 'next-payout.png',
  totalReferred: 'total-referred.png',
  vexticon: 'vesticon.webp',
 staketicon: 'stakingicon.webp',
vestreticon: 'vestreicon.webp',
};


const MainPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activePage, setActivePage] = useState("earning");






  const { buy, maxBalances } = useContract(); // Extract buy and maxBalances
  const [selectedAmount, setSelectedAmount] = useState(50); // Default amount
  const [paymenType, setPaymentType] = useState("package1"); // Default payment type
  const [balances, setBalances] = useState({ usdt: 0, busd: 0, eth: 0 }); // User balances
  const [loading, setLoading] = useState(false); // Loading state




  // Function to change payment type
  const handlePaymentTypechange = (type) => {
    setPaymentType(type);
    console.log("Payment type updated to:", type);
  };

  // Function to handle package purchase
  const handleBuy = async () => {
    setLoading(true);



    try {
      console.log(`Purchasing ${paymenType} with amount ${selectedAmount}`);
      await buy(paymenType, selectedAmount); // Call buy function
      toast.success("Purchase successful!");
    } catch (error) {
      console.error("Error during purchase:", error);
      toast.error("Purchase failed!");
    } finally {
      setLoading(false);
    }
  };




  const { isConnected, address } = useWeb3ModalAccount();
  const { open } = useWeb3Modal();
  const { stake, vestTokens,unstake,claimVesting,claimAirdrop,claimStakingRewards   } = useContract();

  const [modalType, setModalType] = useState(""); // To determine if it’s a stake or vest modal
  const [tokenAmount, setTokenAmount] = useState("");
  const [isStakeProcessing, setStakeProcessing] = useState(false); // Loading state for staking
  const [isVestProcessing, setVestProcessing] = useState(false); // Loading state for vesting
  const [isClaimVestingLoading, setClaimVestingLoading] = useState(false); // Loading state for claim vest
  const [isUnstakeLoading, setUnstakeLoading] = useState(false); // Loading state for unstake
  const [isStakeLoading, setStakeLoading] = useState(false); // Loading state for stake
  const [isClaimRewardLoading, setClaimRewardLoading] = useState(false); // Loading for claiming rewards

  const openModal = (type) => {
    setModalType(type); // Type is either 'stake' or 'vest'
    setTokenAmount(""); // Clear token amount
  };

  const closeModal = () => {
    setModalType("");
    setTokenAmount("");
  };

  const [isClaimStakingLoading, setClaimStakingLoading] = useState(false); // Loading for claiming rewards

  const handleConfirm = async () => {
    if (modalType !== "claimVest" &&  !tokenAmount || isNaN(tokenAmount) || Number(tokenAmount) <= 0) {
      toast.error("Please enter a valid amount.");
      return;
    }

    try {
      if (modalType === "stake") {
        setStakeProcessing(true); // Set staking processing state
        console.log(`Staking ${tokenAmount} tokens...`);
        await stake(tokenAmount);
        toast.success("Tokens staked successfully!");
      } 
      else if (modalType === "unstake") {
        console.log(`Unstaking ${tokenAmount} tokens...`);
        await unstake(tokenAmount); // Call the unstake function
        toast.success("Tokens unstaked successfully!");
      }
      
      else if (modalType === "claimVest") {
        console.log("Claiming all vested tokens...");
        await claimVesting(); // Call the claim vested tokens function
        toast.success("Vested tokens claimed successfully!");
      }else if (modalType === "vest") {
        setVestProcessing(true); // Set vesting processing state
        console.log(`Vesting ${tokenAmount} tokens...`);
        await vestTokens(tokenAmount);
        toast.success("Tokens vested successfully!");
      }
      else if (modalType === "claimReward") {
        setClaimRewardLoading(true);
        console.log("Claiming rewards...");
        await claimAirdrop();
        toast.success("Rewards claimed successfully!");
      }
      else if (modalType === "claimStaking") {
        setClaimStakingLoading(true);
        console.log("Claiming rewards...");
        await claimStakingRewards();
        toast.success("Staking Rewards claimed successfully!");
      }

      closeModal();
    } catch (error) {
      console.error(`Error during ${modalType}:`, error.message || error);
      toast.error(`Failed to ${modalType === "stake" ? "stake" : modalType === "unstake" ? "unstake" : modalType === "claimVesting" ? "claim vested tokens" : "claim rewards"}.`);
    } finally {
      if (modalType === "stake") setStakeLoading(false);
      if (modalType === "unstake") setUnstakeLoading(false);
      if (modalType === "claimVesting") setClaimVestingLoading(false);
      if (modalType === "claimReward") setClaimRewardLoading(false);   
      if (modalType === "claimStaking") setClaimStakingLoading(false);
    }
  };

  const Card = ({ title, value, iconSrc, additionalText }) => (
    <div className="card-border-wide w-full sm:w-[280px] md:w-[320px] lg:w-[350px] xl:w-[400px] mx-auto p-[1.07px] bg-gray-800">
      <div className="p-4 rounded-[21px] flex justify-between space-y-2 items-center relative z-[2] w-full">
        <div className="flex gap-4 items-end">
          <div>
            <p className="text-[12px] leading-[12px] text-[#798DA3]">{title}</p>
            <p className="text-[19px] leading-[26px] font-semibold">{value}</p>
          </div>
          <p className="text-[#01B574] test-[15px] leading-[20px]">{additionalText}</p>
        </div>
        <span className="bg-[#6a11cb] rounded-lg w-10 h-10 flex items-center justify-center">
        <img src={iconSrc} alt="" className="w-[26px] h-[26px]" />
      </span>
      </div>
    </div>
  );
  
  


  const [airdroppedTokens, setAirdroppedTokens] = useState("0");
  const { getTotalAirdropClaim } = useContract();


  useEffect(() => {
    const fetchAirdropData = async () => {
      try {
        if (isConnected) {
          const totalClaimed = await getTotalAirdropClaim();
          setAirdroppedTokens(totalClaimed);
        } else {
          setAirdroppedTokens("0"); // Default if not connected
        }
      } catch (error) {
        console.error("Error fetching airdrop details:", error);
      }
    };

    fetchAirdropData();
  }, [isConnected, getTotalAirdropClaim]);


  
  const [stakingClaimedTokens, setstakingclaedokens] = useState("0");
  const { getTotalStakingClaim } = useContract();


  useEffect(() => {
    const fetchAirdropData = async () => {
      try {
        if (isConnected) {
          const totalClaimed = await getTotalStakingClaim();
          setstakingclaedokens(totalClaimed);
        } else {
          setstakingclaedokens("0"); // Default if not connected
        }
      } catch (error) {
        console.error("Error fetching airdrop details:", error);
      }
    };

    fetchAirdropData();
  }, [isConnected, getTotalStakingClaim]);







  

  const [stakingTokens, setstakingTTokens] = useState("0");
  const { getstakingTokensClaim,getvestingtotalTokensClaim,getNextStakingClaimTime } = useContract();


  useEffect(() => {
    const fetchStakingData = async () => {
      try {
        if (isConnected) {
          const totalClaimed = await getstakingTokensClaim();
          setstakingTTokens(totalClaimed);
        } else {
          setstakingTTokens("0"); // Default if not connected
        }
      } catch (error) {
        console.error("Error fetching staking details:", error);
      }
    };

    fetchStakingData();
  }, [isConnected, getstakingTokensClaim]);




  const [VestingtotalTokensclaim, setVestingclaimTTokens] = useState("0");

  useEffect(() => {
    const fetchvestData = async () => {
      try {
        if (isConnected) {
          const totalClaimed = await getvestingtotalTokensClaim();
          setVestingclaimTTokens(totalClaimed);
        } else {
          setVestingclaimTTokens("0"); // Default if not connected
        }
      } catch (error) {
        console.error("Error fetching staking details:", error);
      }
    };

    fetchvestData();
  }, [isConnected, getvestingtotalTokensClaim]);




  const [nextClaimTime, setNextClaimTime] = useState(null);
  const [remainingTime, setRemainingTime] = useState("");
  const { getNextVestingClaimTime } = useContract();


  useEffect(() => {
    const fetchNextClaimTime = async () => {
      try {
        if (isConnected) {
          const claimTime = await getNextVestingClaimTime();
          setNextClaimTime(claimTime);
        } else {
          setNextClaimTime(null); // Default when not connected
        }
      } catch (error) {
        console.error("Error fetching next vesting claim time:", error);
      }
    };

    fetchNextClaimTime();
  }, [isConnected, getNextVestingClaimTime]);

  useEffect(() => {
    if (!nextClaimTime || nextClaimTime === 0) {
      setRemainingTime("...");
      return;
    }

    const interval = setInterval(() => {
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      const timeLeft = nextClaimTime - currentTime;

      if (timeLeft <= 0) {
        clearInterval(interval);
        setRemainingTime("Claim Available Now!");
      } else {
        const days = Math.floor(timeLeft / 86400);
        const hours = Math.floor((timeLeft % 86400) / 3600);
        const minutes = Math.floor((timeLeft % 3600) / 60);
        const seconds = timeLeft % 60;

        setRemainingTime(
          `${days > 0 ? `${days}d ` : ""}${hours}h ${minutes}m ${seconds}s`
        );
      }
    }, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [nextClaimTime]);







  const [previousClaimTime, setPreviousClaimTime] = useState(null);


  const vestingInterval = 2592000; // Example: 30 days in seconds

  useEffect(() => {
    const fetchVestingTimes = async () => {
      try {
        if (isConnected) {
          const nextClaim = await getNextVestingClaimTime();
          setNextClaimTime(nextClaim);
          
          // Calculate previous claim time by subtracting vestingInterval from nextClaimTime
          const previousClaim = nextClaim ? nextClaim - vestingInterval : null;
          setPreviousClaimTime(previousClaim);
        }
      } catch (error) {
        console.error("Error fetching vesting times:", error);
      }
    };

    fetchVestingTimes();
  }, [isConnected, getNextVestingClaimTime, vestingInterval]);

  const formatDate = (timestamp) => {
    if (!timestamp || timestamp <= 0) return "Unavailable";
    const date = new Date(timestamp * 1000); // Convert Unix to milliseconds
    return date.toLocaleString(); // Convert to local date/time format
  };







  const navigate = useNavigate(); // Use navigate for programmatic navigation

  const handleItemClick = (page) => {
    setActivePage(page);
    setIsSidebarOpen(false); // Close sidebar when an item is clicked
    navigate(`/${page.toLowerCase()}`); // Navigate to the selected page
  };




  const [nextClaimTimestamp, setNextClaimTimestamp] = useState(null); // UNIX timestamp for next claim
  const [countdown, setCountdown] = useState("..."); // Remaining time display




  // Fetch Next Staking Claim Timestamp
  useEffect(() => {
    const fetchNextClaimTimestamp = async () => {
      try {
        if (isConnected) {
          const claimTimestamp = await getNextStakingClaimTime(); // Fetch claim timestamp from the contract
          setNextClaimTimestamp(claimTimestamp);
        } else {
          setNextClaimTimestamp(null); // Default when not connected
        }
      } catch (error) {
        console.error("Error fetching next staking claim time:", error);
      }
    };

    fetchNextClaimTimestamp();
  }, [isConnected, getNextStakingClaimTime]);

  // Update Countdown Timer
  useEffect(() => {
    if (!nextClaimTimestamp || nextClaimTimestamp === 0) {
      setCountdown("...");
      return;
    }

    const interval = setInterval(() => {
      const currentTime = Math.floor(Date.now() / 1000); // Current UNIX time in seconds
      const timeLeft = nextClaimTimestamp - currentTime;

      if (timeLeft <= 0) {
        clearInterval(interval);
        setCountdown("Claim Available Now!");
      } else {
        const days = Math.floor(timeLeft / 86400);
        const hours = Math.floor((timeLeft % 86400) / 3600);
        const minutes = Math.floor((timeLeft % 3600) / 60);
        const seconds = timeLeft % 60;

        setCountdown(
          `${days > 0 ? `${days}d ` : ""}${hours}h ${minutes}m ${seconds}s`
        );
      }
    }, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [nextClaimTimestamp]);


 

  const { fetchTokenPriceusd } = useContract();
  const [n2gtokenPrice, setTokenPrice] = useState(null); // State to store token price

  useEffect(() => {
      const getTokenPrice = async () => {
          try {
              const price = await fetchTokenPriceusd();
              setTokenPrice(price); // Store scaled token price
          } catch (error) {
            
          }
      };

      getTokenPrice();
  }, [fetchTokenPriceusd]);




  const { getUserVestedTokens ,getUserStakedAmount} = useContract();
  const [vestedTokens, setVestedTokens] = useState("0");
  const userAddress = "0xYourWalletAddress"; // Replace with dynamic wallet address

  useEffect(() => {
    const fetchVestedTokens = async () => {
      try {
        console.log("Fetching vested tokens...");
        const tokens = await getUserVestedTokens(userAddress);
        console.log("Vested Tokens:", tokens);
        setVestedTokens(tokens);
      } catch (error) {
        console.error("Error fetching vested tokens:", error);
      }
    };

    if (userAddress) {
      fetchVestedTokens();
    }
  }, [userAddress, getUserVestedTokens]);






  useEffect(() => {
    const fetchVestedData = async () => {
      try {
        if (isConnected) {
          const totalClaimed = await getUserVestedTokens();
          setVestedTokens(totalClaimed);
        } else {
          setVestedTokens("0"); // Default if not connected
        }
      } catch (error) {
        console.error("Error fetching staking details:", error);
      }
    };

    fetchVestedData();
  }, [isConnected, getUserVestedTokens]);





  const [amountStaked, setAmountStaked] = useState("0");

  useEffect(() => {
    const fetchStakedAmount = async () => {
      if (isConnected) {
        try {
          const stakedAmount = await getUserStakedAmount(address); // Use the method from useContract
          setAmountStaked(stakedAmount);
        } catch (error) {
          console.error("Error fetching staked amount:", error);
          toast.error("Failed to fetch staked amount.");
        }
      }
    };
  
    fetchStakedAmount();
  }, [isConnected, address, getUserStakedAmount]);
  






// Staking claim time state
const [stakingNextClaimTime, setStakingNextClaimTime] = useState(null);
const [stakingRemainingTime, setStakingRemainingTime] = useState("");




// Fetch Staking Claim Time
useEffect(() => {
  const fetchStakingClaimTime = async () => {
    if (isConnected && address) {
      try {
        const claimTime = await getNextStakingClaimTime(address);
        console.log("Fetched Staking Next Claim Time:", claimTime); // Debug log
        setStakingNextClaimTime(claimTime);
      } catch (error) {
        console.error("Error fetching staking claim time:", error);
      }
    }
  };

  fetchStakingClaimTime();
}, [isConnected, address, getNextStakingClaimTime]);

// Update Remaining Time for Staking
useEffect(() => {
  if (!stakingNextClaimTime || stakingNextClaimTime <= 0) {
    setStakingRemainingTime("Unavailable");
    return;
  }

  const interval = setInterval(() => {
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    const timeLeft = stakingNextClaimTime - currentTime;

    if (timeLeft <= 0) {
      setStakingRemainingTime("Claim Available Now!");
      clearInterval(interval); // Stop interval once claim is available
    } else {
      const days = Math.floor(timeLeft / 86400);
      const hours = Math.floor((timeLeft % 86400) / 3600);
      const minutes = Math.floor((timeLeft % 3600) / 60);
      const seconds = timeLeft % 60;

      setStakingRemainingTime(
        `${days > 0 ? `${days}d ` : ""}${hours}h ${minutes}m ${seconds}s`
      );
    }
  }, 1000);

  return () => clearInterval(interval); // Cleanup on unmount
}, [stakingNextClaimTime]);






















  const [n2gBalance, setN2GBalance] = useState(0); // State to store the N2G balance
  const { myTokenBalance } = useContract(); // Destructure myTokenBalance function


  useEffect(() => {
    const fetchBalance = async () => {
      if (isConnected) {
        try {
          const balance = await myTokenBalance();
          setN2GBalance(balance);
        } catch (error) {
          console.error("Error fetching N2G balance:", error);
          toast.error("Failed to fetch N2G balance.");
        }
      }
    };

    fetchBalance();
  }, [isConnected]);
  const isProcessing = modalType === "stake" ? isStakeProcessing : isVestProcessing;

  // Function to render dynamic page content
  const renderContent = () => {
    switch (activePage) {
      case "earning":
        return (
          <div className="px-2 sm:px-4 py-6 max-w-screen-xl mx-auto   ">
              <h2 className="text-xl sm:text-2xl font-bold text-center mb-6 " style={{color:"white"}}>
              N2G Earnings Manager

  </h2>
          {/* Stats Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {/* Cards */}
            <Card
              title="$N2G Holdings"
              value={parseFloat(n2gBalance).toFixed(0)}
              iconSrc="global.png"
            />
                    <Card
              title="Total $N2G Staking Token"
              value={amountStaked}
              iconSrc="stakingicon.webp"
              additionalText=""
            />
            <Card
              title="Total $N2G Vest Token"
              value={vestedTokens}
              iconSrc="vesticon.webp"
              additionalText=""
            />
            <Card
              title="Total $N2G Vest Rewards Paid"
              value={parseFloat(airdroppedTokens).toFixed(0)}
              iconSrc="vestreicon.webp"
            />
            <Card
              title="Total $N2G Staking Rewards Paid"
              value={parseFloat(stakingClaimedTokens).toFixed(0)}
              iconSrc="t-rewards-paid.png"
            />
            <Card
              title="Next $N2G Vest Payout Time"
              value={remainingTime}
              iconSrc="last-payout-time.png"
              additionalText=""
            />
            <Card
              title="Next $N2G Staking Payout"
              value={stakingRemainingTime}
              iconSrc="next-payout.png"
              additionalText=""
            />
            <Card
              title="Available $N2G Staking Rewards"
              value={parseFloat(stakingTokens).toFixed(0)}
              iconSrc="referral-earnings.png"
            />
            <Card
              title="Available $N2G Vest Rewards"
              value={parseFloat(VestingtotalTokensclaim).toFixed(0)}
              iconSrc="total-referred.png"
              additionalText=""
            />
      
          </div>
        </div>
        
        
        
 
        );
      case "Purchase":
        return (






          <div className="bg-[#1C1C1C] p-6 rounded-lg shadow-lg text-white max-w-lg mx-auto mt-20 flex justify-center items-center">
          <div className="w-full flex flex-col">
            {/* Purchase Amount */}
            <div className="flex items-center justify-between mb-2">
              <span className="text-[#747474] text-sm font-normal" style={{color:"white"}}>Your Purchase Amount:</span>
              <span className="text-white text-sm font-normal">${selectedAmount.toFixed(1)}</span>
            </div>
            
            {/* Amount Input */}
            <div style={{ marginBottom: "20px", width: "100%", maxWidth: "500px" }}>
              <input
                type="number"
                value={selectedAmount}
                onChange={(e) => setSelectedAmount(Number(e.target.value))}
                readOnly
                style={{
                  width: "100%",
                  padding: "12px",
                  fontSize: "16px",
                  borderRadius: "10px",
                  border: "1px solid #444",
                  backgroundColor: "#1f1f1f",
                  color: "white",
                  textAlign: "center",
                }}
                placeholder="Enter Amount"
              />
            </div>
        
            {/* Amount Selection Buttons */}
            <div style={{ width: "100%", maxWidth: "500px" }}>
              <h3 className="text-white text-sm font-semibold mb-3">Select Amount</h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: "10px",
                  justifyItems: "center",
                }}
              >
                {[50, 250, 500, 1000].map((amount, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      setSelectedAmount(amount);
                      handlePaymentTypechange(`package${index + 1}`);
                    }}
                    style={{
                      padding: "12px",
                      backgroundColor: selectedAmount === amount ? "#1E90FF" : "#1f1f1f",
                      color: "#fff",
                      border: "none",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      fontSize: "14px",
                      width: "100%",
                    }}
                  >
                    ${amount}
                  </button>
                ))}
              </div>
            </div>
        
            {/* Connect Wallet or Purchase Now */}
            <div style={{ marginTop: "20px", width: "100%", maxWidth: "500px" }}>
              {!isConnected ? (
                <button
                  onClick={() => open("Connect")}
                  className="w-full px-4 py-2 bg-gradient-to-r from-[#6a11cb] to-[#2575fc] text-white rounded-lg hover:opacity-80 transition"
                >
                  Connect Wallet
                </button>
              ) : (
                <button
                  onClick={handleBuy}
                  className={`w-full px-4 py-2 bg-gradient-to-r from-[#6a11cb] to-[#2575fc] text-white rounded-lg hover:opacity-80 transition ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                  disabled={loading}
                >
                  {loading ? "LOADING..." : "Purchase Now"}
                </button>
              )}
            </div>
          </div>
        </div>
        
        
        
        );
      case "Stake":
        return (
          <div className="p-6 ">
          {/* Header */}

    
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6  grind">
            {/* Stake Section */}
            <div className="bg-[#1C1C1C] p-6 rounded-lg shadow-lg text-white">
            <div className="w-full flex flex-col">
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">APY:</span>
                                                <span className="text-white text-base font-normal">30%</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">Earn:</span>
                                                <span className="text-white text-base font-normal">N2G Reward</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">Deposit Fee:</span>
                                                <span className="text-white text-base font-normal">0%</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">Harvest Lockup:</span>
                                                <span className="text-white text-base font-normal"> days</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-2">
                                                <span className="tracking-[-0.052em] text-base font-semibold gradient-text">
                                                N2G Reward
                                                </span>
                                                <span className="text-white text-base font-normal">Earned</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-xl font-semibold text-[#747474]"> N2G Reward</span>
                                                <span className="bg-[#242424] font-semibold text-base info-container px-2 py-1 text-[#747474]">
                                                    Harvest
                                                </span>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="tracking-[-0.052em] text-base font-semibold gradient-text">
                                                N2G Reward
                                                </span>
                                                <span className="text-white text-base font-normal">Staked</span>
                                            </div>
                                        </div>
                                        
              <button
                className="w-full px-4 py-2 bg-gradient text-white rounded"
                onClick={() => openModal("stake")}
              >
                Stake Tokens
              </button>

              
            </div>
    
            {/* Vesting Section */}
            <div className="bg-[#1C1C1C] p-6 rounded-lg shadow-lg text-white">
            <div className="w-full flex flex-col">
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">APY:</span>
                                                <span className="text-white text-base font-normal">50%</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">Earn:</span>
                                                <span className="text-white text-base font-normal">N2G Reward</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">Deposit Fee:</span>
                                                <span className="text-white text-base font-normal">0%</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">Harvest Lockup:</span>
                                                <span className="text-white text-base font-normal"> days</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-2">
                                                <span className="tracking-[-0.052em] text-base font-semibold gradient-text">
                                                    N2G Reward
                                                </span>
                                                <span className="text-white text-base font-normal">Earned</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-xl font-semibold text-[#747474]"> N2G Reward</span>
                                                <span className="bg-[#242424] font-semibold text-base info-container px-2 py-1 text-[#747474]">
                                                    Harvest
                                                </span>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="tracking-[-0.052em] text-base font-semibold gradient-text">
                                                    N2G Reward
                                                </span>
                                                <span className="text-white text-base font-normal">Vested</span>
                                            </div>
                                        </div>
              <button
                className="w-full px-4 py-2 bg-gradient text-white rounded"
                onClick={() => openModal("vest")}
              >
                Vest Tokens
              </button>
            </div>
              {/* Unstake Section */}
        <div className="bg-[#1C1C1C] p-6 rounded-lg shadow-lg text-white">
        <div className="w-full flex flex-col">
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">APY:</span>
                                                <span className="text-white text-base font-normal">30%</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">Earn:</span>
                                                <span className="text-white text-base font-normal">N2G Reward</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">Deposit Fee:</span>
                                                <span className="text-white text-base font-normal">0%</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-[#747474] text-base font-normal">Harvest Lockup:</span>
                                                <span className="text-white text-base font-normal"> days</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-2">
                                                <span className="tracking-[-0.052em] text-base font-semibold gradient-text">
                                                N2G Reward
                                                </span>
                                                <span className="text-white text-base font-normal">Earned</span>
                                            </div>
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-xl font-semibold text-[#747474]"> N2G Reward</span>
                                                <span className="bg-[#242424] font-semibold text-base info-container px-2 py-1 text-[#747474]">
                                                    Harvest
                                                </span>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="tracking-[-0.052em] text-base font-semibold gradient-text">
                                                N2G Reward
                                                </span>
                                                <span className="text-white text-base font-normal">Staked</span>
                                            </div>
                                        </div>
          <button
            className="w-full px-4 py-2 bg-gradient text-white rounded"
            onClick={() => openModal("unstake")}
          >
            Unstake Tokens
          </button>
        </div>
        {/* Claim Vested Tokens */}
        <div className="bg-[#1C1C1C] p-6 rounded-lg shadow-lg text-white">
          <h2 className="text-xl font-bold mb-4 text-white">Withdraw Vested Tokens</h2>
          <p className="mb-4">Click the button below to claim all your vested tokens.</p>
          <button
            className={`w-full px-4 py-2 rounded ${
              isClaimVestingLoading ? "bg-gray-500 cursor-not-allowed" : "bg-gradient text-white"
            }`}
            onClick={async () => {
              try {
                setClaimVestingLoading(true);
                console.log("Claiming vested tokens...");
                await claimVesting();
                toast.success("Vested tokens claimed successfully!");
              } catch (error) {
                console.error("Error claiming vested tokens:", error.message || error);
                toast.error("Failed to claim vested tokens.");
              } finally {
                setClaimVestingLoading(false);
              }
            }}
            disabled={isClaimVestingLoading}
          >
            {isClaimVestingLoading ? "Processing..." : "Withdraw Vested Tokens"}
          </button>
        </div>

       < div className="bg-[#1C1C1C] p-6 rounded-lg shadow-lg text-white">
          <h2 className="text-xl font-bold mb-4" style={{color:"white"}}>Claim Daily Rewards</h2>
          <p className="mb-4">Click the button below to claim your rewards </p>
          <button
            className={`w-full px-4 py-2 rounded ${isClaimRewardLoading ? "bg-gray-500 cursor-not-allowed" : "bg-gradient text-white"}`}
            onClick={async () => {
              try {
                setClaimRewardLoading(true);
                console.log("Claiming rewards...");
                await claimAirdrop();
                toast.success("Rewards claimed successfully!");
              } catch (error) {
                console.error("Error claiming rewards:", error.message || error);
                toast.error("Failed to claim rewards.");
              } finally {
                setClaimRewardLoading(false);
              }
            }}
            disabled={isClaimRewardLoading}
          >
            {isClaimRewardLoading ? "Processing..." : "Claim Rewards"}
          </button>
        </div>
        
       < div className="bg-[#1C1C1C] p-6 rounded-lg shadow-lg text-white">
          <h2 className="text-xl font-bold mb-4" style={{color:"white"}}>Claim Staking Rewards</h2>
          <p className="mb-4">Click the button below to claim your rewards </p>
          <button
            className={`w-full px-4 py-2 rounded ${isClaimStakingLoading ? "bg-gray-500 cursor-not-allowed" : "bg-gradient text-white"}`}
            onClick={async () => {
              try {
                setClaimStakingLoading(true);
                console.log("Claiming rewards...");
                await claimStakingRewards();
                toast.success("Rewards claimed successfully!");
              } catch (error) {
                console.error("Error claiming rewards:", error.message || error);
                toast.error("Failed to claim rewards.");
              } finally {
                setClaimStakingLoading(false);
              }
            }}
            disabled={isClaimStakingLoading}
          >
            {isClaimStakingLoading ? "Processing..." : "Claim Stake Rewards"}
          </button>
        </div>
          </div>
    
          {/* Modal */}
          
          {modalType && modalType !== "claimVesting" && modalType !== "claimReward" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-[#1C1C1C] p-6 rounded-lg w-[90%] max-w-md">
            <h2 className="text-xl font-bold mb-4 text-white">{modalType === "stake" ? "Stake Tokens" : "Unstake Tokens"}</h2>
            <p className="mb-4 text-white">Enter the amount of tokens you want to {modalType}.</p>
            <input
              type="number"
              value={tokenAmount}
              onChange={(e) => setTokenAmount(e.target.value)}
              placeholder="Enter amount"
              className="w-full p-2 rounded bg-[#2B2B2B] text-white text-base mb-4"
            />
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-500 text-white rounded"
                onClick={closeModal}
                disabled={isStakeLoading || isUnstakeLoading}
              >
                Cancel
              </button>
              <button
                className={`px-4 py-2 rounded ${
                  isStakeLoading || isUnstakeLoading ? "bg-gray-500 cursor-not-allowed" : "bg-gradient text-white"
                }`}
                onClick={handleConfirm}
                disabled={isStakeLoading || isUnstakeLoading}
              >
                {modalType === "stake" && isStakeLoading ? "Staking..." : modalType === "unstake" && isUnstakeLoading ? "Unstaking..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
       
        </div>
        );
      case "transactions":
        return (
          <div style={{marginTop:"25px"}}>
            <h1 className="text-3xl font-bold mb-6 text-white">Transactions</h1>
            <div className="p-6 bg-[#1C1C1C] rounded-lg text-white">
              <p>View your recent transactions here.</p>
            </div>
          </div>
        );
      default:
        return <p className="text-white">Select a section to display content.</p>;
    }
  };

  return (


    <div className="flex bg-[#0E1118] min-h-screen">
    {/* Top Navbar */}
    <div
      className="fixed top-0 left-0 right-0 bg-[#1C1C1C] p-2 flex items-center justify-between z-50 md:hidden"
      style={{ height: '80px' }} // Keeps the bar height fixed
    >
      <div
        className={`flex items-center ${isSidebarOpen ? 'hidden' : 'flex'}`}
      >
        {/* Mobile logo visible when sidebar is closed */}
        <div className="flex items-center justify-center">
          <img
            src={"logo1.webp"} // Mobile Logo
            alt="Mobile Logo"
            className="h-auto"
            style={{
              width: '150px', // Size for mobile
              maxWidth: '400px', // Prevent excessive resizing
            }}
          />
        </div>
      </div>
      <button
        className="text-white p-2 bg-[#4D8DFF] rounded-md"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        style={{
          background: 'linear-gradient(to right, #6a11cb, #2575fc)',
          height: '40px',
          width: '22%',
        }}
      >
        {isSidebarOpen ? '✖' : '☰'}
      </button>
    </div>

    {/* Sidebar */}
    <div
      className={`fixed top-0 left-0 h-full w-64 bg-[#1C1C1C] p-6 flex flex-col transform ${
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
      } md:translate-x-0 transition-transform duration-300 z-40`}
    >
      {/* Desktop logo in sidebar visible only on desktop and when sidebar is closed on mobile */}
      <div className={`flex items-center justify-center md:flex ${isSidebarOpen ? 'hidden' : 'flex'}`} style={{marginTop:"-30px"}}> 
        <img
          src={"logo1.webp"} // Desktop Logo
          alt="Desktop Logo"
          className="w-40 sm:w-48 h-auto"

        />
      </div>

      <ul className="space-y-4 mt-5 flex-grow">
        {menuItems.map((item) => (
          <li
            key={item.name}
            onClick={() => {
              setActivePage(item.name);
              setIsSidebarOpen(false);
            }}
            className={`flex items-center p-4 rounded-lg cursor-pointer ${
              activePage === item.name
                ? 'bg-[#6a11cb] text-white'
                : 'hover:bg-gray-700 text-white'
            }`}
          >
            <span
              className={`bg-[#1bfbfe] rounded-lg w-10 h-10 flex items-center justify-center ${
                activePage === item.name ? 'bg-white' : 'bg-gray-700'
              }`}
            >
              <img
                src={item.icon}
                alt={`${item.name} icon`}
                className="w-6 h-6" // Icon size
              />
            </span>
            <span className="ml-3">
              {item.name.charAt(0).toUpperCase() + item.name.slice(1)}
            </span>
          </li>
        ))}
      </ul>

      {/* Token Price */}
      <div className="text-center text-white text-sm bg-[#6a11cb] py-3">
      $N2G Price:  {isConnected
  ? `${n2gtokenPrice} USD`
  : "0.0005 USD"}

    </div>
    </div>
    

    {/* Content */}
    <div className="ml-0 md:ml-64 p-8 flex-1 bg-[#0E1118]">{renderContent()}</div>
  </div>



  
  
  );
};

export default MainPage;
